"use client";

import { createDisclosureStore } from "./6E4KKOSB.js";

// src/dialog/dialog-store.ts
function createDialogStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createDisclosureStore(props);
}
export { createDialogStore };